/* ShowSecretComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const Renderer = require("./ShowSecretRenderer");

class ShowSecretComponent extends EventEmitter {
    constructor(context) {
        super(context);
        /**
         * @type {?{privateKey: string, publicKey: string}}
         * @private
         */
        this._context = context;
        this._clientId = _.get(this._context, "summary.credentials.clientId");
        this._secret = _.get(this._context, "summary.credentials.clientSecret");
        this._registerListeners();
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer && this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    _shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();
        this.removeAllListeners();
        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._data = null;
                this._renderer = null;
                this._shutdownProm = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    closePopUp() {
        this.rejectPopUp({userRejected: true});
    }

    resolvePopup(data) {
        this._context.resolve(data);
    }

    rejectPopUp(data) {
        this._context.reject(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _triggerShutdown() {
        /**
         * @event ShowKeysComponent#Shutdown
         */
        this.emit("Shutdown");
    }

    _triggerData(data) {
        /**
         * @event ShowKeysComponent#Data
         * @param {{privateKey: string, publicKey: string}} data - new data
         */
        this.emit("Data", data);
    }

    _setData(data, silent) {
        this._data = data;
        if (!silent) {
            this._triggerData(data);
        }
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    getData() {
        return this._data;
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = ShowSecretComponent;
